<template>
  <v-app-bar app dense>
    <v-app-bar-nav-icon @click="toggleDrawer()" />
    <v-toolbar-title class="pl-1">
      <div class="header-content" @click="navigateTo('/products')">
        <scantrust-pro-logo-icon size="32" class="logo-icon"></scantrust-pro-logo-icon>
        <scantrust-pro-text-icon size="115" class="text-logo"></scantrust-pro-text-icon>
      </div>
    </v-toolbar-title>
  </v-app-bar>
</template>

<script>

import { mapGetters } from 'vuex'
import ScantrustProTextIcon from '@/components/icons/ScantrustProText'
import ScantrustProLogoIcon from '@/components/icons/ScantrustProLogo'

export default {
  components: {
    ScantrustProTextIcon,
    ScantrustProLogoIcon
  },
  computed: {
    ...mapGetters(['currentPlan', 'profile']),

    planName () {
      if (this.currentPlan && this.currentPlan.name) {
        return this.currentPlan.name
      }
      return ''
    }
  },
  methods: {
    toggleDrawer () {
      this.$emit('on-toggle')
    },
    navigateTo (path) {
      this.$router.push(path)
    }
  }
}
</script>

<style lang="sass" scoped>

.v-app-bar
  display: flex
  align-items: center

.header-content
  display: flex
  align-items: center
  cursor: pointer

.logo-icon
  flex-shrink: 0

.text-logo
  margin-left: 8px

.account-icon
  position: relative
  .plan-pill
    position: absolute
    top: 2px
    right: 0px

</style>
